import { Component, OnInit, isDevMode } from '@angular/core';
import { RoutableTabGroup, ITabSubRoute, DialogService } from '@wephone-utils';
import { AgentPageComponent } from '../../pages/agent-page/agent-page.component';
import { EnterpriseContactsPage } from '../../pages/enterprise-contacts/enterprise-contacts';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MyvoicemailqueueComponent } from '@wephone-common';
import { _tk, _ti } from '@wephone-translation';
import { TranslateService } from '@ngx-translate/core';
import { CallHistoryComponent } from '../call-history/call-history.component';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { CallLogListPage } from '../history/calllog-list/calllog-list';
import { SmsinHandlerComponent } from '@wephone-sms/component';
import { SmsService } from 'src/app/wephone-sms/service/sms.service';
import { MyvoicemailsComponent } from '../voicemails/myvoicemails/myvoicemails.component';
import { ConfigManager } from '@wephone-core/wephone-core.module';
import { SmsComponent } from '../sms/sms.component';
import { FeatureName } from '@wephone-core/system';

@Component({
  selector: 'phone-dashboard',
  templateUrl: './phone-dashboard.component.html',
  styleUrls: ['./phone-dashboard.component.scss'],
  host: { class: 'flex-page-component' },
  providers: [TranslateService]
})
export class PhoneDashboardPage extends RoutableTabGroup {
  config: PerfectScrollbarConfigInterface = {};

  childRoutes: ITabSubRoute[] = [
    {
      name: 'agent_page',
      component: AgentPageComponent,
      label: _tk('tab_navigation_menu.call'),
      icon: 'call'
    },
    // {
    //   name: 'enterprise-contacts',
    //   component: EnterpriseContactsPage,
    //   label: _tk('tab_navigation_menu.enterprise_contact'),
    //   icon: 'supervisor_account'
    // },
    // {
    //   name: 'phonevoicemailqueue',
    //   component: MyvoicemailqueueComponent,
    //   label: _tk('menu.voicemail'),
    //   icon: 'keyboard_voice'
    // },
  ];

  constructor(
    authService: AuthenticationService,
    private smsService: SmsService,
  ) {
    super();

    const isSMSFeatureEnabled = ConfigManager.getInstance().hasFeature(FeatureName.SMS);

    if (isSMSFeatureEnabled) {
      this.childRoutes.push(
        {
          name: 'sms-handler',
          // component: SmsinHandlerComponent,
          component: SmsComponent,
          label: _tk('tab_navigation_menu.sms_handler'),
          icon: 'message',
          badge: () => {
            return this.smsService.getTotalConversationUnread();
          }
        }
      );
    }

    this.childRoutes.push({
      name: 'phonevoicemailqueue',
      component: MyvoicemailsComponent,
      label: _tk('menu.voicemail'),
      icon: 'voicemail'
    });

    if (!authService.isUser()) {
      this.childRoutes.push({
        name: 'callhistory',
        component: CallHistoryComponent,
        label: _tk('tab_navigation_menu.call_log'),
        icon: 'history'
      });
    } else {
      this.childRoutes.push({
        name: 'calllog',
        component: CallLogListPage,
        label: _tk('tab_navigation_menu.call_log'),
        icon: 'history'
      });
    }
  }
}
